
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import AmountDisplayerFilterable from '@/components/reports-v3/components/filterables/AmountDisplayerFilterable.vue';
import FilterWidget from '@/components/reports-v3/components/codedWidgets/shared/FilterWidget.vue';
import { PermissionsGroup } from '@/store/models.def';
import { getTableName } from '@/worker/db/sqlHelpers';
import IncludeUnappliedToggle from '@/components/IncludeUnappliedToggle.vue';
import settingx from '@/store/modules/settingx';

@Component({
	components: {
		AmountDisplayerFilterable,
		IncludeUnappliedToggle,
	},
})
export default class SupplierTotalOutstandingNumberDisplayer extends FilterWidget {
	public get permissionIds(): PermissionsGroup[] {
		return ['suppliers'];
	}

	public filterIds: Array<
		| 'date'
		| 'dateAsOf'
		| 'dateRange'
		| 'stockItems'
		| 'agents'
		| 'customers'
		| 'suppliers'
	> = ['suppliers', 'agents', 'dateAsOf'];

	public amount: number = 0;

	public get includeUnapplied() {
		return settingx.now.includeUnapplied;
	}

	public get expensiveHook() {
		const { selectedAsOfDate, selectedAgents, selectedSuppliers, includeUnapplied } = this;
		return JSON.stringify([
			selectedAsOfDate,
			selectedAgents,
			selectedSuppliers,
			includeUnapplied,
		]);
	}

	public async expensiveCalc() {
		this.generateLoadingText(0.2, 0.3);

		const escapeStr = (s: string) => s.replace(/'/g, '\'\'');
		const table = getTableName('supplierTrades');

		let supplierFilter = '';
		if (this.selectedSuppliers.length > 0) {
			const list = this.selectedSuppliers.map((c) => `'${escapeStr(c)}'`).join(',');
			supplierFilter = ` AND "CODE" IN (${list})`;
		}
		let agentFilter = '';
		if (this.selectedAgents.length > 0) {
			const list = this.selectedAgents.map((a) => `'${escapeStr(a)}'`).join(',');
			agentFilter = ` AND "AGENT" IN (${list})`;
		}

		const jobId = this.currentJobId;
		const queryHead = await this._ensureTablesLoaded(['supplierTrades']);
		this.checkInterrupted(jobId);
		this.generateLoadingText(0.5);

		const result = await queryHead.rawQuery(`
			SELECT
				SUM(CASE WHEN "DOCTYPE" IN ('PI','SD') THEN TRY_CAST("LOCALOSAMOUNT" AS DOUBLE) ELSE 0 END) as os_amt,
				SUM(CASE WHEN "DOCTYPE" IN ('SC','ST','SI','SP') THEN TRY_CAST("LOCALUNAPPLIEDAMT" AS DOUBLE) ELSE 0 END) as minus_unapplied,
				SUM(CASE WHEN "DOCTYPE" = 'SF' THEN TRY_CAST("LOCALUNAPPLIEDAMT" AS DOUBLE) ELSE 0 END) as plus_unapplied
			FROM ${table}
			WHERE TRY_CAST("DOCDATE" AS BIGINT) <= ${this.selectedAsOfDate}
				${supplierFilter}${agentFilter}
		`);
		this.checkInterrupted(jobId);

		const osAmount = Number(result[0] && result[0].os_amt) || 0;
		if (this.includeUnapplied) {
			const minusUnapplied = Number(result[0] && result[0].minus_unapplied) || 0;
			const plusUnapplied = Number(result[0] && result[0].plus_unapplied) || 0;
			this.amount = osAmount - minusUnapplied + plusUnapplied;
		} else {
			this.amount = osAmount;
		}

		this.generateLoadingText(1);
		this.saveHistory('amount');
	}
}
